import { BUTTON, DIV } from "./dom";
import { zoomIn, zoomOut } from "./state";

const names = {
  minus: 0xf068,
  plus: 0xf067,
};

export type Names = typeof names;

export type IconName = keyof Names;

const fcp = String.fromCodePoint;

export const nameToString = (n: IconName) => 
  fcp(names[n]);


export const zoomInButton = () =>BUTTON(
  "zoom-in zoom-buttons--element",
  zoomIn,
  DIV("btn-icon", "+"),
);
export const zoomOutButton =()=> BUTTON(
  "zoom-out zoom-buttons--element",
  zoomOut,
  DIV("btn-icon", "-"),
);
